import { useSelector } from "react-redux";
import {
  selectSelectedElement,
  selectSelectedElementType,
} from "../../app/slices/TrainingSlice";
import { ISequence } from "../../models/interactions/Sequence";
import { InteractionType } from "../../models/interactions/Interaction";
import { useMemo } from "react";
import PiButton from "../../components/PiButton";
import { SequenceNodeData } from "./SequenceNode";
import { Node, useReactFlow } from "@xyflow/react";
import {
  getTakeSequenceGroupLabel,
  getVisibleSequenceNodes,
  isTakeSequenceGroupNode,
} from "./takeSequenceEditor";

export default function SequenceOutliner() {
  const sequence = useSelector(selectSelectedElement) as ISequence;
  const selectedElementType = useSelector(selectSelectedElementType);
  const { setCenter } = useReactFlow();

  const nodesToOutline = useMemo(() => {
    return getVisibleSequenceNodes(sequence.nodes, selectedElementType).filter(
      (node) =>
        node.data.interaction.type === InteractionType.Sequence ||
        isTakeSequenceGroupNode(node),
    );
  }, [selectedElementType, sequence]);

  const focusOnNode = (node: Node<SequenceNodeData>) => {
    if (!node) return;

    //const x = node.position.x + (node.width ?? 0) / 2;
    const y = node.position.y + 100;
    const x = node.position.x + 100;
    // const y = node.position.y;
    setCenter(x, y, { zoom: 1.5, duration: 500 });
  };

  const buttons = useMemo(() => {
    return nodesToOutline.map((node) => {
      const name =
        node.data.interaction.type === InteractionType.Sequence
          ? "Main Sequence"
          : getTakeSequenceGroupLabel(node);

      return (
        <div className="w-full h-[36px]" key={node.id}>
          <PiButton
            onClick={() => focusOnNode(node)}
            variant="piBlueOutlined"
            key={node.id}
          >
            {name}
          </PiButton>
        </div>
      );
    });
  }, [nodesToOutline]);

  return <div className="flex flex-col gap-y-[12px]">{buttons}</div>;
}
